import React from 'react'
import { Grid as BaseGrid, styled } from '@mui/material'
import { Link } from 'react-router-dom'
import { PUBLIC_URL } from '../../config/settings/environment'

export const CertificateLink = styled(Link)`
  background-color: ${({ disabled, theme }) =>
    disabled ? theme.palette.custom.gray[20.2] : theme.palette.custom.blue[50.1]};
  border: ${({ disabled, theme }) => (disabled ? 'none' : `1px solid ${theme.palette.blue[50]}`)};
  border-radius: 4px;
  box-shadow: 0 2px 7px 0
    ${({ disabled, theme }) => (disabled ? theme.palette.custom.gray[20.15] : theme.palette.custom.blue[50.15])};
  color: ${({ disabled, theme }) => (disabled ? theme.palette.brand.white : theme.palette.blue[50])};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  display: inline-flex;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-weight: 700;
  justify-content: center;
  line-height: 18px;
  padding: 12px 24px;
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
  text-decoration: none;
  transition:
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out,
    color 0.15s ease-in-out;
  user-select: none;
  width: ${props => props.width};

  &:focus {
    box-shadow: 0 0 0 0.2rem ${props => props.theme.palette.blue[50.4]};
    outline: 0;
  }

  &:active {
    transform: scale(0.98);
  }

  &:hover {
    background-color: ${props => props.theme.palette.blue[50]};
    border-color: ${props => props.theme.palette.blue[50]};
    color: ${props => props.theme.palette.brand.white};

    & img {
      background-color: ${props => props.theme.palette.brand.white};
    }
  }
`

export const Column = styled(({ margin, padding, ...props }) => <BaseGrid item {...props} />)`
  &.MuiGrid-root {
    display: flex;
    margin: ${props => props.margin || '0'};
    padding: ${props => props.padding || '0 5px'};
  }
`

export const Image = styled('img')`
  background-color: ${props => props.theme.palette.blue[50]};
  margin-right: 12px;
  mask: url(${PUBLIC_URL}/assets/images/click.svg) no-repeat center / contain;
  width: 34px;

  &:hover {
    background-color: ${props => props.theme.palette.brand.white};
  }
`

export const ImageDownload = styled('img')`
  background-color: ${props => props.theme.palette.gray[50]};
  margin-right: 12px;
  mask: url(${PUBLIC_URL}/assets/images/FileDownload.svg) no-repeat center / contain;
  width: 34px;

  &:hover {
    background-color: ${props => props.theme.palette.brand.white};
  }
`

export const ImageInfo = styled('img')`
  background-color: ${props => props.theme.palette.gray[50]};
  margin-right: 12px;
  mask: url(${PUBLIC_URL}/assets/images/Info.svg) no-repeat center / contain;
  width: 34px;

  &:hover {
    background-color: ${props => props.theme.palette.brand.white};
  }
`

export const ButtonGrayLink = styled(Link)`
  background-color: ${({ disabled, theme }) =>
    disabled ? theme.palette.custom.gray[20.2] : theme.palette.custom.gray[50.1]};
  border: ${({ disabled, theme }) => (disabled ? 'none' : `1px solid ${theme.palette.gray[50]}`)};
  border-radius: 4px;
  box-shadow: 0 2px 7px 0
    ${({ disabled, theme }) => (disabled ? theme.palette.custom.gray[20.15] : theme.palette.custom.gray[50.15])};
  color: ${({ disabled, theme }) => (disabled ? theme.palette.brand.white : theme.palette.gray[50])};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  display: inline-flex;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-weight: 700;
  justify-content: center;
  line-height: 18px;
  padding: 12px 24px;
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
  text-decoration: none;
  transition:
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out,
    color 0.15s ease-in-out;
  user-select: none;
  width: ${props => props.width};

  &:focus {
    box-shadow: 0 0 0 0.2rem ${props => props.theme.palette.blue[50.4]};
    outline: 0;
  }

  &:active {
    transform: scale(0.98);
  }

  &:hover {
    background-color: ${props => props.theme.palette.blue[50]};
    border-color: ${props => props.theme.palette.blue[50]};
    color: ${props => props.theme.palette.brand.white};

    & img {
      background-color: ${props => props.theme.palette.brand.white};
    }
  }
`
